import React from 'react';
import PropTypes from 'prop-types';
import { compose } from '../../../services/utilityFunctions';
import translate from '../../../commonComponents/translate';
import withCSRF from '../../../commonComponents/withCSRF';
import Modal from '../../../commonComponents/modal/Modal';
import ModalHeader from '../../../commonComponents/modal/ModalHeader';
import ModalFooter from '../../../commonComponents/modal/ModalFooter';

function RestartCourseModal({ t, onClose, onConfirm }) {
  return (
    <Modal onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-content">
          <ModalHeader title={t('academy.detail.scorm.modal_restart_course_title')} onClose={onClose} />
          <div className="modal-body">
            <div className="container-fluid">
              <div className="row">
                <div className="portlet-body form">
                  <p style={{ paddingLeft: '20px' }}>{t('academy.detail.scorm.modal_restart_course_description')}</p>
                </div>
              </div>
            </div>
          </div>
          <ModalFooter
            onSave={onConfirm}
            onCancel={onClose}
            saveText={t('confirm')}
            cancelText={t('cancel')}
            saveIsLoader
          />
        </div>
      </div>
    </Modal>
  );
}

RestartCourseModal.propTypes = {
  t: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default compose(
  withCSRF,
  translate,
)(RestartCourseModal);
